enum AvatarType {
  User = 'user',
  Company = 'company',
}

export default AvatarType
